import { supabase } from '../lib/supabase';

export const exportSettingsService = {
  async getSettings(userId, projectId) {
    try {
      const { data, error } = await supabase
        ?.from('project_export_settings')
        ?.select('settings')
        ?.eq('user_id', userId)
        ?.eq('project_id', projectId)
        ?.single();

      if (error && error?.code !== 'PGRST116') throw error; // PGRST116 = no rows
      return { data: data?.settings || null, error: null };
    } catch (error) {
      console.error('Error fetching export settings:', error?.message);
      return { data: null, error };
    }
  },

  async saveSettings(userId, projectId, settings) {
    try {
      const { error } = await supabase
        ?.from('project_export_settings')
        ?.upsert(
          { user_id: userId, project_id: projectId, settings, updated_at: new Date()?.toISOString() },
          { onConflict: 'user_id,project_id' }
        );

      if (error) throw error;
      return { error: null };
    } catch (error) {
      console.error('Error saving export settings:', error?.message);
      return { error };
    }
  },

  // ── Presets ────────────────────────────────────────────────────────────────
  async getPresets(userId) {
    try {
      const { data, error } = await supabase
        ?.from('export_report_presets')
        ?.select('*')
        ?.eq('user_id', userId)
        ?.order('created_at', { ascending: true });

      if (error) throw error;
      return { data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching export presets:', error?.message);
      return { data: [], error };
    }
  },

  async savePreset(userId, name, settings) {
    try {
      const { data, error } = await supabase
        ?.from('export_report_presets')
        ?.insert({ user_id: userId, name: name?.trim(), settings })
        ?.select()
        ?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error saving export preset:', error?.message);
      return { data: null, error };
    }
  },

  async updatePreset(presetId, userId, name, settings) {
    try {
      const { data, error } = await supabase
        ?.from('export_report_presets')
        ?.update({ name: name?.trim(), settings, updated_at: new Date()?.toISOString() })
        ?.eq('id', presetId)
        ?.eq('user_id', userId)
        ?.select()
        ?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error updating export preset:', error?.message);
      return { data: null, error };
    }
  },

  async deletePreset(presetId, userId) {
    try {
      const { error } = await supabase
        ?.from('export_report_presets')
        ?.delete()
        ?.eq('id', presetId)
        ?.eq('user_id', userId);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      console.error('Error deleting export preset:', error?.message);
      return { error };
    }
  },
};
